import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pg-response',
  templateUrl: './pg-response.component.html',
  styleUrls: ['./pg-response.component.scss']
})
export class PgResponseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
